export const numberFormatCurrency = (value) => {
  return '$' + new Intl.NumberFormat('en-US').format(value || 0)
}

export const numberFormatThousands = (value) => {
  return `${Math.round(value / 1000)}K`
}
